import React, { useEffect, useState } from "react";
import { USER_API } from "../common/common";
import { getDomain, getImageUrl, Logout } from "../common/Funcation";
import { getApi, notifyError, postApi } from "../service";
import Slider from "react-slick";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  getTheme,
} from "../common/StyleSeter";
import Cookies from "universal-cookie";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

const cookies = new Cookies();
const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const DD = useSelector((e: any) => e.domainDetails);
  const playNowColor =
    String(DD?.playNowButtonColor || "")
      .trim()
      .replace(/;+\s*$/, "") ||
    getTheme(DD?.colorSchema)?.backgroundColor ||
    "#ffb80c";
  const playNowIsGradient = /gradient\s*\(/i.test(playNowColor);
  const homeData = useSelector((e: any) => e.homeData);
  const HeaderData = useSelector((e: any) => e.Header);
  const marketListDetails = useSelector((e: any) => e.marketListDetails);

  const matchCount = useSelector((e: any) => e.matchCount);
  const isLoader = useSelector((e: any) => e.loader);
  const [pageData, setPageData] = useState<any>(homeData);
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [casinoUrlLoading, setCasinoUrlLoading] = useState<boolean>(false);
  // console.log({ homeData })
  const SliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [loadingImages, setLoadingImages] = useState<any>(
    homeData && Object.keys(homeData).length > 0 ? [] : []
  );
  console.log("laoding Images", loadingImages);
  useEffect(() => {
    if (!homeData || Object.keys(homeData).length === 0) {
      dispatch({ type: "MAIN_LOADER", payload: true });
    } else {
      dispatch({ type: "MAIN_LOADER", payload: false });
    }
    getPageData();
    return () => { };
  }, []);

  useEffect(() => {
    if (homeData && Object.keys(homeData).length > 0) {
      setPageData(homeData);
      dispatch({ type: "MAIN_LOADER", payload: false });
    }
  }, [homeData]);

  const handleImageLoad = (imageId: string) => {
    setLoadingImages((prevLoadingImages: any[]) =>
      prevLoadingImages.filter((id: string) => id !== imageId),
    );
  };

  const handleImageError = (imageId: string) => {
    setLoadingImages((prevLoadingImages: any[]) =>
      prevLoadingImages.filter((id: string) => id !== imageId),
    );
  };
  const [isLoaderFlow, setLoaderFlow] = useState<any>(false);
  useEffect(() => {
    // Skip loader logic entirely when using cached data
    if (homeData && Object.keys(homeData).length > 0) {
      return;
    }

    if (loadingImages.length === 0 && isLoaderFlow) {
      dispatch({ type: "MAIN_LOADER", payload: false });
    } else if (loadingImages.length > 0) {
      dispatch({ type: "MAIN_LOADER", payload: true });
    }
    setLoaderFlow(true);
  }, [loadingImages]);

  const getPageData = async () => {
    console.log("pageData", pageData);
    const domainName = getDomain();
    let data = {
      api: `${USER_API.HOME}?domain=${domainName}`,
      value: {
        domain: domainName,
      },
    };

    await getApi(data)
      .then(function (response) {
        console.log("response", response);
        setPageData(response.data.data);
        dispatch({ type: "SET_HOME_DATA", payload: response.data.data });

        // Turn off loader immediately after data is received
        dispatch({ type: "MAIN_LOADER", payload: false });
      })
      .catch((err) => {
        // Turn off loader on error
        dispatch({ type: "MAIN_LOADER", payload: false });
        if (err.response.data.statusCode === 401) {
          // Logout()
          // navigate('/login')
        }
      });
  };

  const getCasinoLink = async (item: any) => {
    if (HeaderData?.casinoAccess === false) {
      notifyError("Casino access restricted");
      return;
    }
    const casinoBlocked = marketListDetails?.data?.some(
      (m: any) => m?.name === "Casino" && m.isBlock
    );
    if (casinoBlocked) {
      notifyError("Your casino is block, Contact to your upline.");
      return;
    }
    if (cookies.get("skyTokenFront")) {
      setCasinoUrlLoading(true);
      let data = {
        api: USER_API.CASINO_LOGIN,
        value: {
          id: item._id,
          isMobileLogin: isMobile ? true : false,
          domain: getDomain(),
        },
        token: cookies.get("skyTokenFront") ? cookies.get("skyTokenFront") : "",
      };

      await postApi(data)
        .then(function (response) {
          const target = window.innerWidth <= 768 ? "_self" : "_blank";
          window.open(response?.data?.data?.url, target);
        })
        .catch((err) => {
          console.log(err);
          notifyError(err?.response?.data?.message);

          if (err.response.data.statusCode === 401) {
            Logout();
            // notifyError('Pin unsuccess')
            // navigate('/login')
          }
        })
        .finally(() => {
          setCasinoUrlLoading(false);
        });
    } else {
      // if (isMobile) { navigate('/login') }
      if (isMobile) {
        window.location.pathname = "/login";
      }
      notifyError("please login first");
    }
  };

  // useEffect(() => {
  //   const getUserInfo = async () => {
  //     const userData = await fetch(URL.ipWhoUrl).then((res) => res.json()).catch((err) => console.log("Error: ", err));
  //     const userJson = {
  //       city: userData?.city,
  //       state: userData?.region,
  //       country: userData?.country,
  //       ISP: userData?.connection?.org
  //     }
  //     console.log("User info: ", userJson);
  //   }
  //   getUserInfo();
  // }, []);

  const getDashboardTileClass = (width?: string) => {
    if (width === "squareSize") return "entrance-half";
    if (width === "fullSize") return "entrance-full";
    return "entrance-wide";
  };

  const getDashboardTileStyle = (width?: string): React.CSSProperties | undefined => {
    if (width === "fullSize") {
      return { gridColumn: "1 / -1", width: "100%" };
    }
    return undefined;
  };

  return (
    <div style={{ position: "relative" }}>
      {loadingImages.length > 0 || casinoUrlLoading && (
        <div className="loader_top loader_overlay">
          <div className="">
            <Loader />
          </div>
        </div>
      )}
      <div className="container home">
        <div className="home_wrp" style={{ marginTop: "2px" }}>
          {pageData?.bannersInfo && pageData.bannersInfo.length > 0 && (
            <div className={`home_wrp_promobanner ${bannerLoaded ? 'banner-loaded' : 'banner-loading'}`} style={{ width: "100%", aspectRatio: "1132/211", overflow: "hidden" }}>
              <Slider
                dots={true}
                infinite={true}
                autoplay={true}
                autoplaySpeed={5000}
                speed={1000}
                arrows={true}
                slidesToShow={1}
                slidesToScroll={1}
              >
                {pageData?.bannersInfo.map((item: any, idx: number) => {
                  return (
                    <div key={idx}>
                      <img
                        src={getImageUrl(item.image)}
                        alt="promobanner"
                        loading={idx === 0 ? "eager" : "lazy"}
                        decoding="async"
                        onLoad={() => setBannerLoaded(true)}
                      />
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}

          <div className="gamehall-wrap-simple">
            {pageData?.dashboardImagesInfo.map((item: any, i: any) => {
              return (
                <a
                  key={item.id || item._id || `${item.type}-${item.title}-${i}`}
                  onClick={
                    (item.type === "casino" && item.link === "#") ||
                      item.type === "platform"
                      ? (e) => {
                        e.stopPropagation();
                        getCasinoLink(item);
                      }
                      : () => navigate(item.link)
                  }
                  className={getDashboardTileClass(item.Width)}
                  style={getDashboardTileStyle(item.Width)}
                >
                  {i === 0 && (
                    <dl id="onLiveBoard" className="on_live">
                      <dt>
                        <p className="live_icon">
                          <span></span> LIVE
                        </p>
                      </dt>
                      <dd id="onLiveCount_CRICKET">
                        <p>Cricket</p>
                        <span id="count">{matchCount?.cricket}</span>
                      </dd>

                      <dd id="onLiveCount_SOCCER">
                        <p>Soccer</p>
                        <span id="count">{matchCount?.soccer}</span>
                      </dd>

                      {/* <dd id="onLiveCount_E_SOCCER"><p>E-Soccer
                                            </p><span id="count">0</span></dd> */}

                      <dd id="onLiveCount_TENNIS">
                        <p>Tennis</p>
                        <span id="count">{matchCount?.tennis}</span>
                      </dd>

                      {/* <dd id="onLiveCount_KABADDI"><p>Kabaddi
                                            </p><span id="count">0</span></dd> */}
                    </dl>
                  )}
                  <dl
                    style={{
                      ["--play-now-color" as any]: playNowColor,
                      ...(playNowIsGradient
                        ? {
                          borderBottomColor: "transparent",
                          borderImage: `${playNowColor} 1`,
                        }
                        : { borderBottomColor: playNowColor }),
                    }}
                    onClick={
                      (item.type === "casino" && item.gameCode) ||
                        item.type === "platform"
                        ? (e) => {
                          e.stopPropagation();
                          getCasinoLink(item);
                        }
                        : () => console.log()
                    }
                    className="entrance-title"
                  >
                    <dt>{item.title}</dt>
                    <dd>
                      <span className="playnow_button playnow_button-spark">
                        {" "}
                        Play Now{" "}
                      </span>
                    </dd>
                  </dl>
                  {/* {loadingImages.includes(item.id) &&
                                            <img style={{ width: '50%' }} src={LoaderImage} alt={item.title} />
                                        } */}
                  <img
                    src={getImageUrl(item.image)}
                    alt={item.title}
                    loading={i < 4 ? "eager" : "lazy"}
                    decoding="async"
                    onLoad={() => handleImageLoad(item.id)}
                    onError={() => handleImageError(item.id)}
                  />
                </a>
              );
            })}
          </div>

          {!isLoader && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default Home;
